import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardTitle } from "@/components/ui/card";
import { Plus } from "lucide-react";
import { useState } from "react";

export function Home() {
	const [state, setState] = useState<"home" | "selection">("home");
	const [option, setOption] = useState<"create" | "import">();

	return (
		<>
			{state === "home" && (
				<section className="flex-1 flex items-center justify-center px-6">
					<div className="w-full max-w-2xl text-center">
						<div className="mb-10">
							<h1 className="text-5xl font-bold mb-4 text-white">Welcome to Flux</h1>
							<p className="text-neutral-500 text-lg max-w-md mx-auto">
								A secure multi-chain wallet for Solana and Ethereum. Create or import your wallet to
								get started.
							</p>
						</div>
						<div className="flex gap-4 justify-center">
							<Button
								onClick={() => {
									setState("selection");
									setOption("create");
								}}
								className="h-14 px-8 bg-white hover:bg-neutral-200 text-black font-semibold rounded-xl transition-all"
							>
								<Plus className="h-5 w-5 mr-2" />
								Create New Wallet
							</Button>
							<Button
								onClick={() => {
									setState("selection");
									setOption("import");
								}}
								variant="outline"
								className="h-14 px-8 bg-transparent border-neutral-800 hover:bg-neutral-900 hover:border-neutral-700 text-white hover:text-white font-semibold rounded-xl"
							>
								Import Existing Wallet
							</Button>
						</div>
					</div>
				</section>
			)}

			{state === "selection" && (
				<section className="flex-1 flex items-center justify-center px-6">
					<div className="w-full max-w-2xl text-center">
						<h1 className="text-4xl font-bold mb-4 text-white">Select Blockchain</h1>
						<p className="text-neutral-500 mb-10">
							Choose which blockchain network you want to{" "}
							{option === "create" ? "create" : "import"} a wallet for.
						</p>
						<div className="flex gap-6 justify-center">
							<Card
								onClick={() => {
									window.location.href =
										option === "create"
											? "/create-wallet?chain=solana"
											: "/import-wallet?chain=solana";
								}}
								className="w-48 cursor-pointer bg-neutral-950 border-neutral-800 hover:border-emerald-500/50 transition-all group"
							>
								<CardContent className="flex flex-col items-center py-8">
									<div className="h-16 w-16 rounded-full bg-neutral-900 border border-neutral-800 flex items-center justify-center mb-4 group-hover:scale-110 group-hover:border-emerald-500/50 transition-all">
										<span className="text-2xl font-bold text-emerald-500">S</span>
									</div>
									<CardTitle className="text-white">Solana</CardTitle>
									<CardDescription className="text-neutral-600">Fast & Low fees</CardDescription>
								</CardContent>
							</Card>
							<Card
								onClick={() => {
									window.location.href =
										option === "create"
											? "/create-wallet?chain=ethereum"
											: "/import-wallet?chain=ethereum";
								}}
								className="w-48 cursor-pointer bg-neutral-950 border-neutral-800 hover:border-blue-500/50 transition-all group"
							>
								<CardContent className="flex flex-col items-center py-8">
									<div className="h-16 w-16 rounded-full bg-neutral-900 border border-neutral-800 flex items-center justify-center mb-4 group-hover:scale-110 group-hover:border-blue-500/50 transition-all">
										<span className="text-2xl font-bold text-blue-500">Ξ</span>
									</div>
									<CardTitle className="text-white">Ethereum</CardTitle>
									<CardDescription className="text-neutral-600">Most popular</CardDescription>
								</CardContent>
							</Card>
						</div>
					</div>
				</section>
			)}
		</>
	);
}

export default Home;
